<template>
    <div style="font-size:16px; color: #666; font-family: 'Microsoft YaHei';">
        

        
        <!-- <div id="banner_tabs" class="flexslider">
            <ul class="slides">                
                <li id="bgImg1" style="display: block;">
                    <div class="bg_img1"></div>
                </li>
            </ul>
        </div> -->
        <div style="width:100%; height: 800px;">
            <div class="bg_img1">
                    <div class="h408 bfff mt84 mr35 r" style="height: 350px;border-radius: 20px; ">
                        <ul class="m30">
                            <li class="h40 w280">
                                <div class=" c333" style="text-align: center;font-size: 28px;">欢迎登录</div>
                            </li>
                            <li class="w280 h58"><input  class="w248 plr15 f14 tal  br2" style="border-radius:9px; height: 45px; line-height: 45px;" v-model="loginName" id="email" type="text" placeholder="门牌号/手机号/邮箱" /></li>
                            <li class="w280 h58">
                            <input class="w248 plr15 tal f14 mpt20 br2" style="border-radius:9px; height: 45px; line-height: 45px;"  v-model="loginPwd" type="password" placeholder="登录密码"/></li>
                            <li class="h36 w280  ">
                            <div >
                            <input class="w120 tal f14 l plr15  br2"  style="border-radius:9px; height: 45px; line-height: 45px;" v-model="loginCode" type="text" placeholder="验证码" />
                            </div>
                            <div class="l ml10">
                                <div class="code" @click="refreshCode">
                                    <s-identify :identifyCode="identifyCode"></s-identify>
                                </div>
                            </div>
                            </li>
                            <li class="w280 mt20">
                                <button  class="h36 w280  plr15 f18 dlan" v-on:click="login">登 录</button>                
                            </li>            
                            <li class="w280 h36 f14 mb10"><div class="r"><a href="/reg" target="_blank" class="c333">免费注册</a>
                            &nbsp;&nbsp;
                            <a  class="c333" href="/getpassword">忘记密码</a></div></li>
                            
                        </ul>
                    </div>
            </div>
        </div>
        

        <div id="bottom" class="ba161d28" style="height: 130px;">
            
            <div class="w690 bp30">
                
                <div class=" te_a lh35">
                    Copyright 2006-2019 云客服 www.yunkefu.cn<br/>
                    <a href="https://beian.miit.gov.cn" style="color: rgb(102, 102, 102);font-size:9pt;line-height: 35px;" target="_blank">浙ICP备09072632号</a> 
                    <a href="https://beian.miit.gov.cn" style="color: rgb(102, 102, 102);font-size:9pt;line-height: 35px;" target="_blank">浙B2-2010426</a><br/> 
                    <a href="https://beian.miit.gov.cn" style="color: rgb(102, 102, 102);font-size:9pt;line-height: 35px;" target="_blank">浙公网安备 33010602002226号</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import '../assets/css/index.css'; /*引入公共样式*/
import crypto from 'crypto'
import {setCookie,getCookie} from '../assets/js/cookie.js'
export default {
    data(){
        return{
            msg:'',//密码输入错误请重新输入
            loginName:'',
            loginPwd:'',
            identifyCodes: "1234567890",
            identifyCode: "",
            loginCode: '',
            imgIndex:1,
        }
    },
    mounted() {
        if (window != top){
            top.location.href = location.href;
        }
        this.makeCode(this.identifyCodes, 4);
    },
    methods:{
        login(){
            var that = this;
            if(this.loginName == ""){
                alert("请输入账号")
                return
            }
            if(this.loginPwd == ""){
                alert("请输入密码")
                return
            }
            if(this.loginCode != this.identifyCode){
                alert("验证码不正确")
                return
            }
            var password = this.$options.methods.getmd5(this.$options.methods.getmd5(this.loginPwd)+this.loginName)
            let data = {'loginName':this.loginName,'loginPwd':password,'loginSource':'web'}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/login/login.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(function(res) {
                // console.log(JSON.stringify(res.data))
                if('0000000' == res.data.code)
                {
                    that.GLOBAL.token = res.data.token
                    setCookie('2officesessionid',res.data.token,60*60*10)
                    that.$router.push('/main')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        getmd5(str){
            var a;
            var md5 = crypto.createHash("md5");
            md5.update(str);
            var a = md5.digest('hex');
            return a;
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[
                    this.randomNum(0, this.identifyCodes.length)
                ];
            }
        },
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        qqlogin(){
            location.href = "qqlogin";
        },
        alipaylogin(){
            location.href = "alipayauth"
        },
        user2office() {
            window.open('user_2office', 'blank');
        },
        aboutus() {
            window.open('aboutus', 'blank');
        },
        prev(){
            this.imgIndex = this.imgIndex - 1;
            if(this.imgIndex <= 0)
            {
                this.imgIndex = 3;
            }
            this.showImg(this.imgIndex);
            
        },
        
    }
}
</script>

<style>
.bg_img1 {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: url(../assets/images/Carousel_53.jpg);
    height: 100%;
    background-position: center;
    background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue